import { render, staticRenderFns } from "./SimpleProducts.vue?vue&type=template&id=79974f67&scoped=true"
import script from "./SimpleProducts.vue?vue&type=script&lang=js"
export * from "./SimpleProducts.vue?vue&type=script&lang=js"
import style0 from "./SimpleProducts.vue?vue&type=style&index=0&id=79974f67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79974f67",
  null
  
)

export default component.exports